/**
 * Created by wangqian on 18/6/21.
 * http配置
 */
import axios from 'axios'
// import { AppConfig } from '@/config'
// import store from '@/store/store'
// import router from '@/router'
// import { Message } from 'element-ui'
// import cookie from "@/storage/cookies";


// axios 配置
axios.defaults.timeout = 5000 // 请求超时时间 5000ms
axios.defaults.baseURL = "https://api.sgbwl.com"
// axios.defaults.withCredentials=true
// http request 拦截器
axios.interceptors.request.use(
    config => {
        if (!config.headers['Content-Type']) {
            config.headers = {
                'Content-Type': 'application/x-www-form-=urlencoded;charset=UTF-8',
            };
        }
        // let token = cookie.cookieRead('token')
        // let flag = (config.url == `${AppConfig.host}/api/shop/token`)
        // if (flag) { // 排除登录接口

        // } else {
        //     if (token) { // 非下次自动登录
        //         config.headers.Authorization = `Bearer ${token}`
        //     }
        // }
        // let cookieArea = cookie.cookieRead('area')
        // let area = cookieArea ? JSON.parse(cookieArea) : null
        // if (area) {
        //     if (config.method == 'post') {
        //         config.data = {
        //             ...config.data,
        //             areacode: area.id,
        //         }
        //     } else if (config.method == 'get') {
        //         config.params = {
        //             areacode: area.id,
        //             ...config.params
        //         }
        //     }
        // }
        return config
    },
    err => {
        return Promise.reject(err)
    })

// http response 拦截器
axios.interceptors.response.use(
    response => {
        return response
    },
    error => {
        if (error.response) {
            // switch (error.response.status) {
            //     case 401:
            //         // 401 清除token信息并跳转到登录页面
            //         if(error.response.data.error === "invalid_token"){
            //             store.commit('LOGIN_OUT')
            //             return
            //         }
            //         if (error.response.config.headers.Authorization != 'Basic Z2N0eDpnY3R4') {
            //             store.commit('LOGIN_OUT')
            //             Message.error({
            //                 message: '登录已过期，请重新登录',
            //             })
            //             return
            //         }
            //         break
            //     case 490:
            //         Message.error({
            //             message: error.response.data.msg
            //         })
            //         break
            //     case 500:
            //         // store.commit('LOGIN_OUT')
            //         Message.error({
            //             dangerouslyUseHTMLString: true,
            //             message: `服务器错误`
            //         })
            //         break
            // }
        }
        return Promise.reject(error.response.data)
    })
export default axios


// WEBPACK FOOTER //
// ./src/http/index.js